import React from 'react';
import sortBy from 'lodash/sortBy';
import { Flex, Box, Heading, Text, Button } from '@spothero/ui';
// Strict - @ts-expect-error - ui-backlog not typed, CBA
import { Modal, ModalContent, ModalFooter } from '@spothero/ui-backlog';
import Image from 'common/image';
import PackageInfo from '../package-info';
import EventInfo from '../event-info';
const DetailsModal = ({ modalVisible, onHidden, activePackage, showFooterCTA, }) => {
    const { title, description, events, id } = activePackage?.eventPackage || {};
    const { timezone } = activePackage?.destination || {};
    const eventCount = events?.length;
    const searchLink = `/event-packages-search?id=${id}`;
    // sort events to make sure they are in chronological order
    const sortedEvents = sortBy(events, [
        event => event.starts.replace(/\D/g, ''),
    ]);
    /* eslint-disable react/jsx-no-useless-fragment */
    return (<>
            {modalVisible && (<Modal onHidden={onHidden} className="DetailsModal" data-testid="DetailsModal" title="Package Details">
                    {title ? (<>
                            <ModalContent maxHeight={600}>
                                <PackageInfo title={title} description={description} eventCount={eventCount}/>
                                <Box>
                                    {eventCount ? (<Box marginY={4} paddingTop={4} borderTopWidth="1px" borderColor="gray.200">
                                            <Heading as="h3" variant="h5" marginBottom={4}>
                                                Parking Included
                                            </Heading>
                                            <Flex backgroundColor="gray.50" borderRadius="0.5rem" padding={3} marginBottom={4}>
                                                <Box width={8} height={8} marginRight={3}>
                                                    <Image src="/img/event-packages/icon-time-buffer.svg" alt="Timer Icon" showLoader={false}/>
                                                </Box>
                                                <Text flex="1" fontSize="xs">
                                                    No rush! Every parking
                                                    reservation starts at least{' '}
                                                    <strong>1hr before</strong>{' '}
                                                    the event starts, and ends{' '}
                                                    <strong>1hr after</strong>{' '}
                                                    the event ends, even if it
                                                    runs late.
                                                </Text>
                                            </Flex>
                                            {sortedEvents.map((event, index) => (<EventInfo event={event} key={index} timezone={timezone}/>))}
                                        </Box>) : (<Heading as="h3" textAlign="center">
                                            There are no events available for
                                            this package
                                        </Heading>)}
                                </Box>
                            </ModalContent>
                            {showFooterCTA && (<ModalFooter>
                                    <Flex flexDirection="row-reverse" alignItems="center" textAlign={{
                        base: 'center',
                        tablet: 'left',
                    }} display={{
                        base: 'block',
                        tablet: 'flex',
                    }}>
                                        <Button as="a" href={searchLink} marginBottom={{ base: 2, tablet: 0 }} width={{
                        base: '100%',
                        tablet: 'auto',
                    }}>
                                            Continue with Package
                                        </Button>
                                        <Text fontSize="xs" color="gray.600" marginRight={{ base: 0, tablet: 4 }}>
                                            Next step: choose your parking
                                        </Text>
                                    </Flex>
                                </ModalFooter>)}
                        </>) : (<ModalContent>
                            <Heading as="h3" textAlign="center">
                                Sorry, something went wrong loading the events
                            </Heading>
                        </ModalContent>)}
                </Modal>)}
        </>);
};
export default DetailsModal;
